export default {
  statistics: {
    total_campaigns: 'Kampagner i alt',
    todays_sent_messages: 'Sendte beskeder i dag',
    total_subscribers: 'Abonnenter',
    average_click_rate: 'Gennemsnitlig klikrate',
  },
};
